import React from 'react';
import { Button } from '@/components/ui/button';
import { Phone, Users } from 'lucide-react';
import { useTwilio } from '@/contexts/TwilioContext';
import { motion, AnimatePresence } from 'framer-motion';
import { ConsultantDialer } from './ConsultantDialer';

export function ParkedClientBanner() {
  const { isParked, parkedClientName, parkedClientPhone, resumeCall } = useTwilio();
  const [showConsultantPicker, setShowConsultantPicker] = React.useState(false);

  if (!isParked) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -100, opacity: 0 }}
          className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-yellow-500/95 to-orange-500/95 backdrop-blur-sm shadow-lg border-b-2 border-yellow-600/50"
        >
          <div className="container mx-auto px-4 py-3">
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-3">
                <div className="flex items-center gap-2">
                  <div className="relative">
                    <div className="w-3 h-3 bg-white rounded-full animate-pulse" />
                    <div className="absolute inset-0 w-3 h-3 bg-white rounded-full animate-ping" />
                  </div>
                  <span className="text-2xl">🎵</span>
                </div>
                <div>
                  <p className="text-white font-semibold text-sm">
                    Cliente em espera (ouvindo música)
                  </p>
                  <p className="text-white/90 text-xs">
                    {parkedClientName} • {parkedClientPhone}
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-2">
                <Button
                  onClick={() => resumeCall()}
                  size="sm"
                  className="bg-white hover:bg-white/90 text-yellow-700 font-semibold gap-2"
                >
                  <Phone className="w-4 h-4" />
                  Retomar
                </Button>
                <Button
                  onClick={() => setShowConsultantPicker(true)}
                  size="sm"
                  variant="outline"
                  className="bg-yellow-600 hover:bg-yellow-700 text-white border-white/20 font-semibold gap-2"
                >
                  <Users className="w-4 h-4" />
                  Transferir
                </Button>
              </div>
            </div>
          </div>
        </motion.div>
      </AnimatePresence>

      {/* Consultant Picker Modal */}
      <ConsultantDialer
        isOpen={showConsultantPicker}
        onClose={() => setShowConsultantPicker(false)}
        parkedClientName={parkedClientName || undefined}
        parkedClientPhone={parkedClientPhone || undefined}
      />
    </>
  );
}
